import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Flex, Text } from '@mantine/core';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { useTransactionListsController } from '@dealstack/frontend/investor/pages/TransactionsList/useTransactionListsController';
import { InvestorTransactionsTable } from './InvestorTransactionsTable/InvestorTransactionsTable';

export const TransactionsList = () => {
	const tInvestor = useTranslationInvestor();
	const { transactionsRequest, navigateToDashboard } = useTransactionListsController();
	const transactionsData = transactionsRequest.data?.transactions ?? [];

	return (
		<Flex direction="column" p="2rem">
			<Flex
				align="center"
				gap="0.625rem"
				mb="2rem"
				style={{ cursor: 'pointer' }}
				onClick={navigateToDashboard}
			>
				<Icon variant="arrow-left-v3" size="xl" color={defaultTheme.v3.colors.blue[6]} />
				<Text size="B3Bold" style={{ color: defaultTheme.v3.colors.dark[8] }}>
					{tInvestor('transactions_lists.transactions')}
				</Text>
			</Flex>
			<InvestorTransactionsTable
				data={transactionsData}
				isLoading={transactionsRequest.isLoading || transactionsRequest.isFetching}
			/>
		</Flex>
	);
};
